import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { meta } from "../src/landingPage/datasets/meta";
import { Cookies } from "../src/landingPage/views/LegalPages/Cookies";

const CookiesPage = () => {
  return (
    <>
      <NextHead
        currentPath="/cookie-policy"
        title={meta.cookies.title}
        description={meta.cookies.description}
      />
      <Cookies />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default CookiesPage;
